// extracted by mini-css-extract-plugin
export default {"launchCalendarTab":"C-z","nav":"D-z","heading":"E-z","active":"F-z","mainCard":"G-z"};